<script lang="ts">
	import type { ChatMessage } from '@repo/commons/models'
	import { Button, ButtonType } from '@repo/commons/components'
	import { chatT } from '@repo/commons/i18n/chat'
	import { ChatInput } from './index.ts'

	interface Props {
		onSubmit?: (message: ChatMessage) => void
		onCancel?: () => void
		message?: ChatMessage
	}

	let { onSubmit, onCancel, message }: Props = $props()
	let input: string = $state(message?.utterance ?? '')

	function handleKeydown(e: KeyboardEvent) {
		if (e.key === 'Enter' && !e.shiftKey) {
			e.preventDefault()
			if (!input.trim() || !message) return
			onSubmit?.(message)
		}
	}

	function handleSubmit() {
		if (!input.trim() || !message) return
		onSubmit?.({ ...message, utterance: input })
	}
</script>

<div class="edit-message-container">
	<ChatInput bind:input {handleKeydown} />
	<div class="buttons">
		<Button
			buttonText={$chatT('Button.Cancel')}
			buttonType={ButtonType.INVERSE_OUTLINE}
			onclick={onCancel}
		/>
		<Button
			buttonText={$chatT('Button.Send')}
			buttonType={ButtonType.INVERSE}
			onclick={handleSubmit}
		/>
	</div>
</div>

<style lang="postcss">
	.edit-message-container {
		border-radius: 24px;
		background: rgba(20, 213, 134, 0.2);
		padding: 16px;
		width: 100%;
	}

	.buttons {
		display: flex;
		gap: 8px;
		float: right;
		padding-top: 16px;
	}

	:global(.button-class.inverse-outline) {
		background-color: transparent;
	}

	:global(.button-class.inverse) {
		background-color: rgba(0, 22, 38, 0.9);
		color: #ffffff;
	}
</style>
